export { default as useBounds } from './use-bounds';
export { default as useLock } from './use-lock';
export { default as useScrolledPastSpy } from './use-scrolled-past-spy';

export { useFetch, useFetchEagle, FetchDataProvider } from './use-fetch';

// Data model hooks
export { default as useCountry } from './use-country';
export { default as useModel } from './use-model';
export { default as useOrder } from './use-order';
export { default as useCompletedOrders } from './use-completed-orders';
export { default as useRecentOrders } from './use-recent-orders';
export { default as useGlobalContent } from './use-global-content';



// WEBPACK FOOTER //
// ./src/client/js/view/hooks/index.js